import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { InvoicesGridActionMenuProps } from "./types";

const InvoicesGridActionMenu = ({
  onActionOpen,
  onActionClose,
  actions: {
    returns: {
      show: showReturns,
      enabled: enabledReturns,
      onCreateReturnClick,
    },
    claims: { show: showClaims, enabled: enabledClaims, onCreateClaimsClick },
    vendorDirectClaims: {
      show: showVendorDirectClaims,
      enabled: enabledVendorDirectClaims,
      onCreateVendorDirectClaimClick,
    },
  },
  isLoading,
}: InvoicesGridActionMenuProps) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("invoices");

  return (
    <div>
      <IconButton
        ref={anchorRef}
        onClick={() => {
          onActionOpen();
          setOpen(true);
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        open={open}
        onClose={() => {
          setOpen(false);
          onActionClose();
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorRef.current}
        MenuListProps={{ sx: { minWidth: "0px !important" } }}
      >
        {isLoading && (
          <MenuItem>
            <ListItemIcon>
              <CircularProgress size="1.75rem" />
            </ListItemIcon>
          </MenuItem>
        )}
        {showClaims && (
          <MenuItem
            disabled={!enabledClaims}
            onClick={() => {
              setOpen(false);
              onCreateClaimsClick();
              onActionClose();
            }}
          >
            <ListItemText>
              {t("invoices:allInvoices.dropDown.createClaim")}
            </ListItemText>
          </MenuItem>
        )}
        {showReturns && (
          <MenuItem
            disabled={!enabledReturns}
            onClick={() => {
              setOpen(false);
              onCreateReturnClick();
              onActionClose();
            }}
          >
            <ListItemText>
              {t("invoices:allInvoices.dropDown.createReturn")}
            </ListItemText>
          </MenuItem>
        )}
        {showVendorDirectClaims && (
          <MenuItem
            disabled={!enabledVendorDirectClaims}
            onClick={() => {
              setOpen(false);
              onCreateVendorDirectClaimClick();
              onActionClose();
            }}
          >
            <ListItemText>
              {t("invoices:allInvoices.dropDown.createVendorDirectClaim")}
            </ListItemText>
          </MenuItem>
        )}
        {!isLoading &&
          !showClaims &&
          !showVendorDirectClaims &&
          !showReturns && (
            <MenuItem disabled>
              <ListItemText>
                {t("invoices:allInvoices.actions.button.noActions")}
              </ListItemText>
            </MenuItem>
          )}
      </Menu>
    </div>
  );
};

export default InvoicesGridActionMenu;
